import { Map } from 'immutable';

import { mergeDeepRecursive } from '../../lib/ImmutableUtils';
import { createReducer } from '../../lib/ReducerUtils';

import { BackstageActionTypes as Actions, ExternalActions, Keys } from './constants';

export const BACKSTAGE_INITIAL_STATE = Map({
  [Keys.CURRENT_ROUTE]: null,
});

export default createReducer(BACKSTAGE_INITIAL_STATE, {
  [ExternalActions.ENTER_BACKSTAGE]: onEnterBackstage,
  [ExternalActions.LEAVE_BACKSTAGE]: onLeaveBackstage,
  [Actions.MUTATE_BACKSTAGE_DATA]: mutateBackstageData,
});

function onEnterBackstage(state: $TSFixMe, { payload }: $TSFixMe) {
  return state.set(Keys.CURRENT_ROUTE, payload);
}

function onLeaveBackstage(state: $TSFixMe) {
  return state.set(Keys.CURRENT_ROUTE, null);
}

function mutateBackstageData(state: $TSFixMe, { payload }: $TSFixMe) {
  return mergeDeepRecursive(state, payload);
}
